export const getStock = (state) => {
  const { stock, fetching } = state.pages.shop.availability;
  return { stock, fetching };
};
